export default __webpack_public_path__ + "static/media/sz.4e8fd08e.svg";